<div class="modal fade" id="kt_modal_negotiation_edit" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="fw-bold">Edit Negotiation</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <div class="modal-body scroll-y mx-5 mx-xl-15 my-7">
        <form [formGroup]="negotiationForm" (ngSubmit)="onSubmit()" *ngIf="selectedNegotiation">

          <!-- Stock Details -->
          <div class="mb-7">
            <h3 class="fw-bold text-gray-800 mb-5">Stock Details</h3>
            <div class="row g-4">
              <div class="col-md-6">
                <label class="form-label fw-semibold text-gray-700">Car Name</label>
                <input type="text" class="form-control form-control-solid" [value]="selectedNegotiation.car?.name || '-'" disabled>
              </div>
              <div class="col-md-6">
                <label class="form-label fw-semibold text-gray-700">Make</label>
                <input type="text" class="form-control form-control-solid" [value]="selectedNegotiation.car?.company_name || selectedNegotiation.car?.make || '-'" disabled>
              </div>
              <div class="col-md-6">
                <label class="form-label fw-semibold text-gray-700">Stock/Inventory No</label>
                <input type="text" class="form-control form-control-solid" [value]="selectedNegotiation.car?.inventory_no || '-'" disabled>
              </div>
            </div>
          </div>

          <!-- Customer Details -->
          <div class="mb-7">
            <h3 class="fw-bold text-gray-800 mb-5">Customer Details</h3>
            <div class="row g-4">
              <div class="col-md-6">
                <label class="form-label fw-semibold text-gray-700">Customer Name</label>
                <input type="text" class="form-control form-control-solid" [value]="(selectedNegotiation.user?.title || '') + ' ' + (selectedNegotiation.user?.name || 'Unknown')" disabled>
              </div>
              <div class="col-md-6">
                <label class="form-label fw-semibold text-gray-700">Location</label>
                <input type="text" class="form-control form-control-solid" [value]="(selectedNegotiation.user?.city || '') + (selectedNegotiation.user?.city && selectedNegotiation.user?.country ? ', ' : '') + (selectedNegotiation.user?.country || '')" disabled>
              </div>
            </div>
          </div>

          <!-- Message -->
          <div class="mb-7">
            <label class="form-label fw-semibold text-gray-700">Message</label>
            <textarea class="form-control form-control-solid" rows="3" [value]="selectedNegotiation.message || 'No message'" disabled></textarea>
          </div>

          <!-- Options -->
          <div class="mb-7">
            <h3 class="fw-bold text-gray-800 mb-5">Options</h3>
            <div class="row g-4">
              <div class="col-md-6">
                <div class="form-check form-check-custom form-check-solid">
                  <input class="form-check-input" type="checkbox" [checked]="selectedNegotiation.fob_price" disabled>
                  <label class="form-check-label text-gray-700">FOB Price</label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-check form-check-custom form-check-solid">
                  <input class="form-check-input" type="checkbox" [checked]="selectedNegotiation.cif_price" disabled>
                  <label class="form-check-label text-gray-700">CIF Price</label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-check form-check-custom form-check-solid">
                  <input class="form-check-input" type="checkbox" [checked]="selectedNegotiation.cif_total" disabled>
                  <label class="form-check-label text-gray-700">CIF Total</label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-check form-check-custom form-check-solid">
                  <input class="form-check-input" type="checkbox" [checked]="selectedNegotiation.condition_car" disabled>
                  <label class="form-check-label text-gray-700">Condition Car</label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-check form-check-custom form-check-solid">
                  <input class="form-check-input" type="checkbox" [checked]="selectedNegotiation.send_photos" disabled>
                  <label class="form-check-label text-gray-700">Send Photos</label>
                </div>
              </div>
            </div>
          </div>

          <!-- Created On -->
          <div class="mb-7">
            <label class="form-label fw-semibold text-gray-700">Created On</label>
            <input type="text" class="form-control form-control-solid" [value]="selectedNegotiation.created_at | date:'medium'" disabled>
          </div>

          <!-- Editable Fields -->
          <div class="separator separator-dashed my-7"></div>
          <h3 class="fw-bold text-gray-800 mb-5">Update Details</h3>

          <!-- Status -->
          <div class="mb-7">
            <label class="form-label fw-semibold text-gray-700 required">Status</label>
            <select class="form-select" formControlName="status">
              <option value="">Select Status</option>
              <option *ngFor="let status of statusOptions" [value]="status.value">{{ status.label }}</option>
            </select>
            <div class="text-danger mt-2" *ngIf="negotiationForm.get('status')?.invalid && negotiationForm.get('status')?.touched">
              Status is required
            </div>
          </div>

          <!-- Sales Person -->
          <div class="mb-7">
            <label class="form-label fw-semibold text-gray-700">Sales Person</label>
            <app-searchable-select
              [options]="salesPersonList"
              placeholder="Select Sales Person"
              formControlName="sales_person"
              [clearable]="true">
            </app-searchable-select>
          </div>

          <!-- Actions -->
          <div class="text-end pt-5">
            <button type="button" class="btn btn-light me-3" data-bs-dismiss="modal">Cancel</button>
            <button
              type="submit"
              class="btn btn-primary"
              style="min-width: 180px; height: 44px;"
              [disabled]="isLoading || negotiationForm.invalid">
              <!--begin::Indicator label-->
              <span *ngIf="!isLoading">Update Negotiation</span>
              <!--end::Indicator label-->
              <!--begin::Indicator progress-->
              <span *ngIf="isLoading">
                <span class="spinner-border spinner-border-sm align-middle me-2"></span>
                Please wait...
              </span>
              <!--end::Indicator progress-->
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
